import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createGtm } from '@gtm-support/vue-gtm'
import { vuetify } from './plugins/vuetify'
import { CompatVIcon } from './plugins/compatVIcon'

import stores from './stores'
import router from './router'
import { initContentsquare } from './services/contentsquare'

const app = createApp(App)

// 1) Install non-routing plugins first
app.use(stores)
app.use(i18n)
app.use(vuetify)
app.component('VIcon', CompatVIcon)

// 2) Run bootstrap, then register router + GTM, then mount
async function start() {
  initContentsquare()

  const { initializeSession } = await import('./bootstrap/session')

  let result
  try {
    result = await initializeSession()
  } catch (e) {
    console.error('Bootstrap failed:', e)
    result = { ok: false, reason: 'unknown' as const }
  }

  app.use(router)

  if (!result.ok) {
    router.replace({ name: 'login' }).catch(() => {
      window.location.href = '/auth/login'
    })
  }

  if (import.meta.env.VITE_APP_GTM_ENABLED) {
    app.use(
      createGtm({
        id: import.meta.env.VITE_APP_GTM_KEY,
        debug: false,
        vueRouter: router,
      }),
    )
  }

  app.mount('#app')
}

start()
